import type {
  SupplierRecentlyAddedNewListResponseType,
  SupplierRecentlyAddedNewListRequestType,
} from "@sellar-io/api-v2/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2InfiniteQueryOptions,
  apiV2Request,
  getDefaultInfiniteQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useSupplierRecentlyAddedNew = <
  TData = SupplierRecentlyAddedNewListResponseType,
>(
  params: SupplierRecentlyAddedNewListRequestType,
  options?: ApiV2InfiniteQueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useInfiniteQuery({
    queryKey: [business?.id, ServerStateKeys.SupplierRecentlyAdded, "new"],
    queryFn: ({ pageParam }) =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `supplier-recently-added-new`,
        params: {
          ...params,
          offset: pageParam,
        },
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultInfiniteQueryOptionsV2({
      context: { scope: "nonSupplier", user, business },
      options: { ...options, limit: params.limit },
    }),
  });
};
